import { render } from "./biodata.vue?vue&type=template&id=bdeb23e0&scoped=true"
import script from "./biodata.vue?vue&type=script&lang=js"
export * from "./biodata.vue?vue&type=script&lang=js"

import "./biodata.vue?vue&type=style&index=0&id=bdeb23e0&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdeb23e0"]])

export default __exports__